<template>
    <div class="d-flex align-items-center">
        <div class="html-cell">
            <span v-html="value"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: ["id", "value"],
};
</script>
